import React from 'react';
import PropTypes from 'prop-types';

import { H1 } from './containers/Headers';
import Link from './Link';
import Icon from './icon/Icon';
import { TranslatedCopy } from '../intl/TranslatedCopy';

export const ProfileHeader = ({ headerId }) => (
  <div className='profile__header flex-container row space-between align-center prl4-sm pt3-sm pb3-sm bg-white z1'>
    <Link to='/' data-desc='profile__link_back'>
      <Icon name='chevron-left-cell' alt='left' />
      <span className='body-3 d-sm-h d-lg-ib'>
        <TranslatedCopy id='global.backToGameday' />
      </span>
    </Link>
    <span className='headline-2 d-sm-h d-lg-ib'>
      <i className='g72-swoosh' />
    </span>
    <H1 className='profile__title prl7-sm d-lg-h'>
      <TranslatedCopy id={headerId} />
    </H1>
    <span>&nbsp;</span>
  </div>
);

ProfileHeader.propTypes = {
  headerId: PropTypes.string.isRequired
};

export default ProfileHeader;
